import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";

export interface LegalPage {
  id: number;
  title: string;
  key?: string;
  metaTitle?: string;
  metaKeyword?: string;
  metaDescription?: string;
  content: string;
  status: string;
}

export interface AddLegalPage {
  title: string;
  key: string;
  metaTitle: string;
  metaKeyword: string;
  metaDescription: string;
  content: string;
  status?: string;
}

export interface GetLegalPagesParams {
  page?: number;
  pageSize?: number;
  title?: string;
  status?: string;
  orderBy?: string;
  orderDirection?: string;
  [key: string]: unknown;
}

export class LegalPagesService {
  async getLegalPages(query?: GetLegalPagesParams) {
    return apiService.get("/legal-pages", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getLegalPageDetails(id: number) {
    return apiService.get(`/legal-pages/${id}`);
  }

  async addLegalPage(data: AddLegalPage) {
    return apiService.post("/legal-pages", data);
  }

  async updateLegalPage(id: number, data: Partial<AddLegalPage>) {
    return apiService.put(`/legal-pages/${id}`, data);
  }

  async updateLegalPageStatus(id: number, status: string) {
    return apiService.patch(`/legal-pages/${id}/status`, { status });
  }

  async deleteLegalPage(id: number) {
    return apiService.delete(`/legal-pages/${id}`);
  }
}

export const legalPagesService = new LegalPagesService();
